import { useCallback, useMemo } from 'react';
import { EndPoints } from 'src/config';
import { useFetcher } from 'src/hooks/useFetcher';
import { NullableValue } from 'src/types';

export type AgencyPatchPayload = {
  name: NullableValue;
  lat: NullableValue;
  lang: NullableValue;
  tel: NullableValue;
  email: NullableValue;
  city: NullableValue;
  address: NullableValue;
  currency: NullableValue;
  pricePerKilo?: NullableValue;
  priceMini?: NullableValue;
};

type AgencyPatchResponse = {
  count: number;
};

type Props = {
  agencyId: NullableValue;
};

export const useSubmitAgencyEdit = ({ agencyId }: Props) => {
  const { data, isLoading, error, fetcher, resetData } = useFetcher<AgencyPatchResponse | null>(null);
  const submitEdit = useCallback(
    (agencyPatchPayload: AgencyPatchPayload) => {
      if (!agencyId) {
        return;
      }

      resetData();
      fetcher(EndPoints.updateDashboardAgency.replace(':id', agencyId as unknown as string), {
        requiredToken: true,
        method: 'PATCH',
        body: agencyPatchPayload,
      });
    },
    [fetcher, agencyId, resetData],
  );

  const agencyUpdated = useMemo(() => {
    if (!data) {
      return false;
    }

    return data.count > 0;
  }, [data]);

  return {
    submitEdit,
    error,
    isLoading,
    agencyUpdated,
  };
};
